import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InventoryService } from '@app/shared/services/inventory.service';
import { PopMastrService } from '@app/shared/services/pop-mastr.service';  // Import the service

@Component({
  selector: 'app-add-material',
  templateUrl: './add-material.component.html',
  styleUrls: ['./add-material.component.css']
})
export class AddMaterialComponent implements OnInit {
  @Input() closePopup: Function; // Accept closePopup function as input

  addInvenMaterial: FormGroup; // Form group for the add inventory material form
  isUpdateMode: boolean = false; // Flag to indicate if the form is in update mode
  subcategoryOptions: string[] = [];
  categoryOptions: string[] = []; // List of categories (fetched from backend)
  isPopupVisible: boolean = false;
  masterList: any[] = [];  // This will hold all the materials data (category + subcategory info)
  isLoading: boolean = true; // To track the loading state for category and subcategory

  constructor(
    private formBuilder: FormBuilder,
    private inventoryService: InventoryService,private popMastrService: PopMastrService,
    private cdr: ChangeDetectorRef  // Inject ChangeDetectorRef to manually trigger change detection

  ) { }

  ngOnInit(): void {
    this.initForm(); // Initialize the form when the component initializes
    this.getMasterMaterial();
    this.setupFormListeners(); // Set up value listeners for autofill functionality

  }

  // Initialize the add inventory material form
  initForm() {
    this.addInvenMaterial = this.formBuilder.group({
      category: ['', Validators.required],
      subcategory: ['', Validators.required],
      materialTypeGrade: ['', Validators.required],
      supplier: ['', Validators.required],
      receivedDate: ['', Validators.required],
      materialDescription: ['', Validators.required],
      qty: ['', Validators.required],
      material: ['', Validators.required],
      submaterial: ['', Validators.required],
      location: ['', Validators.required],
      thicknessMicron: [''],
      sizeMM: [''],
      rollNo: [''],
      color: [''],
      inkType: ['']
    });
  }
  // Listen to changes in the relevant fields and autofill materialDescription
  setupFormListeners() {
    // Whenever any of these fields change, update the materialDescription
    this.addInvenMaterial.get('category')?.valueChanges.subscribe(() => {
      this.resetMaterialDescription();  // Reset material description when category changes
      this.updateMaterialDescription(); // Update material description
    });

    this.addInvenMaterial.get('subcategory')?.valueChanges.subscribe(() => {
      this.resetMaterialDescription();  // Reset material description when subcategory changes
      this.updateMaterialDescription(); // Update material description
    });

    this.addInvenMaterial.get('thicknessMicron')?.valueChanges.subscribe(() => {
      this.updateMaterialDescription(); // Update material description
    });

    this.addInvenMaterial.get('sizeMM')?.valueChanges.subscribe(() => {
      this.updateMaterialDescription(); // Update material description
    });

    this.addInvenMaterial.get('color')?.valueChanges.subscribe(() => {
      this.updateMaterialDescription(); // Update material description
    });

    this.addInvenMaterial.get('inkType')?.valueChanges.subscribe(() => {
      this.updateMaterialDescription(); // Update material description
    });
  }
  
    // This function dynamically updates the materialDescription based on selected fields
    updateMaterialDescription() {
      const category = this.addInvenMaterial.get('category')?.value;
      const subcategory = this.addInvenMaterial.get('subcategory')?.value;
      const thickness = this.addInvenMaterial.get('thicknessMicron')?.value;
      const size = this.addInvenMaterial.get('sizeMM')?.value;
      const color = this.addInvenMaterial.get('color')?.value;
      const inkType = this.addInvenMaterial.get('inkType')?.value;
    
      let description = '';
    
      // Check category for Inks or Solvent
      if (category === 'Inks' || category === 'Solvent') {
        // Only populate color and inkType
        if (category && subcategory) {
          description = `${category.toUpperCase()}-${subcategory.toUpperCase()}`;
        }
        if (color) {
          description += ` ${color}`;
        }
        if (inkType) {
          description += ` ${inkType}`;
        }
      } else if (category === 'Rolls' || category === 'Films') {
        // For Rolls or Films, use thickness and size
        if (category && subcategory) {
          description = `${category.toUpperCase()}-${subcategory.toUpperCase()}`;
        }
    
        if (size && thickness) {
          description += ` ${size}x${thickness} Mic`;
        }
    
        // Optionally add color or inkType if provided (for Rolls or Films)
        if (color) {
          description += ` ${color}`;
        }
        if (inkType) {
          description += ` ${inkType}`;
        }
      }
    
      // Set the formatted description to the materialDescription field
      this.addInvenMaterial.get('materialDescription')?.setValue(description);
    }
      // Reset material description when category or subcategory changes
  resetMaterialDescription() {
    this.addInvenMaterial.get('materialDescription')?.setValue('');
  }
    
  // Submit the form (add or update inventory)
  addInventory() {
    if (this.addInvenMaterial) {
      // Log the entire form value to the console
      console.log('Form Values:', this.addInvenMaterial.value);
  
      // You can also log individual fields like this if needed
      console.log('Category:', this.addInvenMaterial.get('category')?.value);
      console.log('Subcategory:', this.addInvenMaterial.get('subcategory')?.value);
      console.log('Material Description:', this.addInvenMaterial.get('materialDescription')?.value);
  
      // Handle your API call here (uncomment to enable)
      this.inventoryService.createInventry(this.addInvenMaterial.value).subscribe(
        (response) => {
          console.log('Inventory item added successfully:', response);
          // Reset the form after successful submission
          this.addInvenMaterial.reset();
        },
        (error) => {
          console.error('Error adding inventory item:', error);
        }
      );
    } else {
      console.log('Form is invalid');
    }
  }
  
  

   // Update subcategories based on the selected category
   updateSubcategories(selectedCategory: string) {
    const selectedCategoryData = this.masterList.filter(item => item.category === selectedCategory);
    
    // Extract subcategories for the selected category
    this.subcategoryOptions = [...new Set(selectedCategoryData.map(item => item.subcategory))];

    // If you want to reset the subcategory field when a category changes, you can set it to an empty string
    this.addInvenMaterial.get('subcategory')?.setValue('');
  }

   // Fetch categories and subcategories from the backend
   getMasterMaterial() {
    this.isLoading = true; // Set loading to true before fetching
    this.popMastrService.getMasterMaterial().subscribe(
      (res: any) => {
        this.masterList = res;  // Store the full list of materials
        console.log(this.masterList);

        // Extract unique categories from the master list
        const uniqueCategories = [...new Set(this.masterList.map(item => item.category))];
        this.categoryOptions = uniqueCategories;  // Assign the unique categories to the categoryOptions array

        this.isLoading = false; // Set loading to false once data is fetched
        this.cdr.detectChanges(); // Manually trigger change detection to update UI immediately
      },
      (err: any) => {
        console.error('Error fetching categories:', err);
        this.isLoading = false; // Set loading to false even if there's an error
      }
    );
  }
  // closePopup() {
  //   this.isPopupVisible = false;
  // }
  openPopup() {
    this.isPopupVisible = true;
  }
// Close the popup when the close button is clicked
onClose(): void {
  if (this.closePopup) {
    this.closePopup();  // Call parent's closePopup method
  }
 // this.isPopupVisible = false; // You can also close it locally here if needed
}
 // Close the Master Popup
 closeMasterPopup() {
  this.isPopupVisible = false;
}

}

